import type { Common } from '@libs/domain';
import { dateToStr } from '@ps-smart-cp/ppfw-client';

export class LedgerFooter implements Pick<Common['schema'], 'approvalNo' | 'entryDate' | 'summary'> {
  private constructor(
    readonly entryDate: Date | null,
    readonly approvalNo: string,
    readonly summary: string,
  ) {}

  static init(date: Date | null) {
    return new LedgerFooter(date, '', '');
  }
}

export class LedgerFooterRaw implements Pick<Common['record'], 'approvalNo' | 'entryDate' | 'summary'> {
  private constructor(
    readonly entryDate: string,
    readonly approvalNo: string,
    readonly summary: string,
  ) {}

  static fromModel({ entryDate, approvalNo, summary }: LedgerFooter) {
    return new LedgerFooterRaw(dateToStr(entryDate, 'yyyyMMdd'), approvalNo, summary);
  }
}
